<template>
  <!-- 发布站内信详情 -->
  <div class="system_mail_detail-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <!-- <el-form-item>
					<el-input v-model="query.id" placeholder="请输入用户id"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button class="pull-right" type="primary" @click="getData">搜索</el-button>
				</el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="handleExport">导出</el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table v-loading="loading" :data="dataList">
        <el-table-column prop="user_id" label="用户uid"></el-table-column>
        <el-table-column prop="updated_at" label="发送时间"></el-table-column>
        <el-table-column prop="content" label="文案"></el-table-column>
        <el-table-column prop="content" label="用户查看">
          <template slot-scope="{row}">
            <span v-if="row.is_read==2">是</span>
            <span v-else>否</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background :page-size="dataMeta.per_page || 15" :total="dataMeta.total || 0" :current-page="page"
        @current-change="handlePageChange" v-if="dataMeta && dataMeta.total > dataMeta.per_page"></el-pagination>
    </div>

  </div>
</template>

<script>
import http, {
  api,
  server,
  getApiData
} from '@/http'
import saveFile from '@/utils/saveFile'

export default {
  props: {},
  data() {
    return {
      loading: false,
      query: {
        page: 1,
        id: undefined,
      },
      dataList: undefined,
      dataMeta: undefined,
    }
  },
  created() {
    this.getData(1)
  },
  methods: {
    handleExport() {
      //导出
      http
        .get(
          api + 'news_list_export/' + this.$route.params.id, {
          responseType: 'arraybuffer'
        }
        )
        .then(res => {
          saveFile(res, {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '站内信用户.xlsx'
          })
        }).finally(() => { })
    },
    getData(num) {
      if (num === 1) {
        this.query.page = 1
      }
      this.loading = true
      let params = this.query
      getApiData(`news_list_info/${this.$route.params.id}`, params)
        .then(res => {
          this.dataList = res.data
          this.dataMeta = res
        })
        .finally(() => {
          this.loading = false
        })
    },
    handlePageChange(page) {
      this.query.page = page
      this.getData()
    },
  },
}

</script>

<style>

</style>
